export enum FatalErrorType {
    BACKEND_ERROR = 'BACKEND_ERROR',
    ERROR_OCCURRED = 'ERROR_OCCURRED',
    NO_BILLING_ACCOUNTS = 'NO_BILLING_ACCOUNTS',
}
